define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/encode',
    '../Util/callbackSystem',
    '../2D/PolylineSymbol',
    '../2D/PolygonSymbol'
], function (
    defaultValue,
    defined,
    encode,
    callbackSystem,
    PolylineSymbol,
    PolygonSymbol
) {
    'use strict'

    /**
     * 矢量图层。
     * <br /><br />
     * <div align='center'>
     * <img src='images/FeatureLayer.png' width='900' height='650' /><br />
     * 矢量效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/FeatureLayer.html|CooWasm FeatureLayer demo}
     * @alias FeatureLayer
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {String} props.url WFS服务根路径。
     * @param {String} props.layerName 图层名称，通常格式为: xx:xxx。
     * @param {String} [props.version=2.0.0] WFS协议版本，通常为1.0.0/1.1.0/2.0.0，推荐使用2.0.0。
     * @param {Number} [props.numPerTile=100] 单个瓦片要素数量。
     * @param {PolylineSymbol} [props.polylineSymbol] 线符号实例。
     * @param {PolygonSymbol} [props.polygonSymbol] 面符号实例。
     * @param {Boolean} [props.bVisible=true] 矢量数据加载时显隐状态。
     * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
     * @example
     * var layer = new CooWasm.FeatureLayer({
     *     url:"http://127.0.0.1/geoserver/ows?,
     *     layerName:"test:test",
     *     polylineSymbol: new CooWasm.PolylineSymbol({}),
     *     version:"2.0.0",
     * },(state)=>{console.log("load status:" + state)})
     */
    class FeatureLayer {
        /**
         * @description WFS服务路径。
         * @type {String}
         */
        url
        /**
        * @description 图层名称，通常格式为: xx:xxx。
        * @type {String}
        */
        layerName
        /**
         * @description WFS协议版本，通常为1.0.0/1.1.0/2.0.0，推荐使用2.0.0。
         * @type {String}
         * @default 2.0.0
         */
        version = "2.0.0"
        /**
         * @description 单个瓦片要素数量。
         * @type {Number}
         * @default 100
         */
        numPerTile = 100
        /**
         * @description 矢量数据显隐状态。
         * @type {Boolean}
         * @default true
         */
        bVisible = true
        /**
         * @description 线符号实例。
         * @type {PolylineSymbol}
         */
        polylineSymbol
        /**
         * @description 面符号实例。
         * @type {PolygonSymbol}
         */
        polygonSymbol
        /**
         * @description 矢量对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 矢量数据源组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description 线符号组件uuid。
         * @type {String}
         * @readonly
         */
        componentPolylineUuid = null
        /**
         * @description 面符号组件uuid。
         * @type {String}
         * @readonly
         */
        componentPolygonUuid = null
        /**
         * @description MeshLayer在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "FeatureLayer"
        static avatarType = "Avatar.Layer.FeatureLayer"
        static componentDataSourceType = "AvatarComponent.DataSource.WFSFeatureSourceComponent"
        static componentPolylineType = "AvatarComponent.Symbol.PolylineSymbolComponent"
        static componentPolygonType = "AvatarComponent.Symbol.PolygonSymbolComponent"

        constructor(props, callback) {
            if (!defined(props)) {
                props = {}
            }
            if (defined(props.build) && props.build == true) {
                this.polylineSymbol = new PolylineSymbol({})
                this.polygonSymbol = new PolygonSymbol({})
                return
            }
            if (!defined(props.url)) {
                console.log("FeatureLayer need url!")
                return
            }
            if (!defined(props.layerName)) {
                console.log("FeatureLayer need layerName!")
                return
            }
            if (!defined(props.polylineSymbol) && !defined(props.polygonSymbol)) {
                console.log("FeatureLayer need polylineSymbol or polygonSymbol!")
                return
            }
            this.polylineSymbol = defaultValue(props.polylineSymbol, null)
            this.polygonSymbol = defaultValue(props.polygonSymbol, null)

            let avatarCategoryName = "Avatar.Layer.FeatureLayer"
            let dataSourceCategoryName = "AvatarComponent.DataSource.WFSFeatureSourceComponent"
            let polylineCategoryName = "AvatarComponent.Symbol.PolylineSymbolComponent"
            let polygonCategoryName = "AvatarComponent.Symbol.PolygonSymbolComponent"
            let categoryNames = ""
            let avatarProps = ""
            let componetProps = ""
            let bPolyline = defined(this.polylineSymbol)
            let bPolygon = defined(this.polygonSymbol)
            //avatar props
            avatarProps += this.toStr("bVisible", props.bVisible, "Visible")
            //wfs component props
            componetProps += this.toStr("url", props.url, "Url")
            componetProps += this.toStr("layerName", props.layerName, "LayerName")
            componetProps += this.toStr("version", props.version, "Version")
            componetProps += this.toStr("numPerTile", props.numPerTile, "NumberOfFeatures")
            componetProps += "#$%"
            categoryNames += dataSourceCategoryName + "#$%"
            //polyline component props
            if (bPolyline) {
                this.polylineSymbol = props.polylineSymbol
                let polylineProps = this.polylineSymbol.properties
                componetProps += polylineProps + "#$%"
                categoryNames += polylineCategoryName + "#$%"
            }
            //polygon component props
            if (bPolygon) {
                this.polygonSymbol = props.polygonSymbol
                let polygonProps = this.polygonSymbol.properties
                componetProps += polygonProps + "#$%"
                categoryNames += polygonCategoryName + "#$%"
            }
            var idInfo = idInfo = Element.prototype.NativeAPI.LoadAvatarAndMultiComponent(encode(avatarCategoryName), encode(avatarProps), encode(categoryNames), encode(componetProps), false, this.bVisible, defined(callback))
            if (idInfo != "") {
                var idArray = idInfo.split('#$%')
                this.avatarUuid = idArray[0]
                if (bPolyline && bPolygon) {
                    this.componentUuid = idArray[1]
                    this.componentPolylineUuid = idArray[2]
                    this.componentPolygonUuid = idArray[3]
                } else if (bPolyline && !bPolygon) {
                    this.componentUuid = idArray[1]
                    this.componentPolylineUuid = idArray[2]
                } else if (!bPolyline && bPolygon) {
                    this.componentUuid = idArray[1]
                    this.componentPolygonUuid = idArray[2]
                }
                //
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.featureLayers.push(this)
                })
            }
        }

        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         * <p>
         * 一般用于多个属性的同时更新，避免性能开销过大。（待启用）
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {String} [props.url] WFS服务根路径。
         * @param {String} [props.layerName] 图层名称，通常格式为: xx:xxx。
         * @param {String} [props.version] WFS协议版本，通常为1.0.0/1.1.0/2.0.0，推荐使用2.0.0。
         * @param {Number} [props.numPerTile] 单个瓦片要素数量。
         * @param {PolylineSymbol} [props.polylineSymbol] 线符号实例。
         * @param {PolygonSymbol} [props.polygonSymbol] 面符号实例。
         * @param {Boolean} [props.bVisible=true] 矢量数据加载时显隐状态。
         * @param {CallbackBoolean} [callback=null] 更新成功后触发的函数回调。
         * @example
         * layer.update({
         *      bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            let uuids = ""
            if (defined(props)) {
                if (defined(props.bVisible)) {
                    this.bVisible = props.bVisible
                    avatarProps += "Visible:" + this.bVisible + "|"
                }
                //wfs component props
                let dataSourceComponentProps = ""
                dataSourceComponentProps += this.toStr("url", props.url, "Url")
                dataSourceComponentProps += this.toStr("layerName", props.layerName, "LayerName")
                dataSourceComponentProps += this.toStr("version", props.version, "Version")
                dataSourceComponentProps += this.toStr("numPerTile", props.numPerTile, "NumberOfFeatures")
                componentProps += dataSourceComponentProps + "#$%"
                uuids += this.componentUuid + "#$%"
                //polyline component props
                if (defined(props.polylineSymbol)) {
                    componentProps += this.polylineSymbol.update(props.polylineSymbol) + "#$%"
                    uuids += this.componentPolylineUuid + "#$%"
                }
                //polygon component props
                if (defined(props.polygonSymbol)) {
                    componentProps += this.polygonSymbol.update(props.polygonSymbol) + "#$%"
                    uuids += this.componentPolygonUuid + "#$%"
                }
                callbackSystem.register("UpdateAvatarAndMultiComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndMultiComponent(encode(this.avatarUuid), encode(uuids), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }


        /**
         * 从场景中定位自身(自动根据数据包围盒定位，不可修改定位参数)。
         * @param {CallbackBoolean} [callback=null] 飞行结束后触发的函数回调。
         * @example
         * // 定位图层
         * layer.locate(()=>{console.log("locate done!")})
         */
        locate(callback) {
            callbackSystem.register("", "LocateAvatar", (state) => {
                if (defined(callback)) {
                    callback(state)
                }
            })
            Element.prototype.NativeAPI.LocateAvatar(encode(this.avatarUuid))
        }

        /**
         * 获取图层包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * // 获取属性
         * layer.getProperties()
         * console.log(layer.spatialReference)
         */
        getProperties() {
            if (!defined(this.avatarUuid) || !defined(this.componentUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                }
            }
            let avatarAcSize = Element.prototype.NativeAPI.Avatar_GetAvatarComponentsSize(pAvatar)
            for (let j = 0; j < avatarAcSize; ++j) {
                let pAc = Element.prototype.NativeAPI.Avatar_GetAvatarComponent(pAvatar, j)
                let propSize = Element.prototype.NativeAPI.AvatarComponent_GetPropertiesSize(pAc)
                let pObjType = Element.prototype.NativeAPI.AvatarComponent_GetObjectType(pAc)
                let pName = Element.prototype.NativeAPI.ObjectType_GetName(pObjType)
                let pUuid = Element.prototype.NativeAPI.AvatarComponent_GetUuid(pAc)
                let uuid = Element.prototype.NativeAPI.Uuid_GetId(pUuid)
                for (let z = 0; z < propSize; ++z) {
                    if (pName == "WFSFeatureSourceComponent") {
                        this.componentUuid = uuid
                        let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        if (name == "Url") {
                            this.url = value
                        } else if (name == "LayerName") {
                            this.layerName = value
                        } else if (name == "Version") {
                            this.version = value
                        } else if (name == "NumberOfFeatures") {
                            this.numPerTile = parseInt(value)
                        }
                    } else if (pName == "PolylineSymbolComponent") {
                        this.componentPolylineUuid = uuid
                        let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        if (name == "AltitudeMode") {
                            this.polylineSymbol.altitudeMode = value
                        } else if (name == "Altitude") {
                            this.polylineSymbol.altitude = parseFloat(value)
                        } else if (name == "MinVisibleDistance") {
                            this.polylineSymbol.minDistance = parseFloat(value)
                        } else if (name == "MaxVisibleDistance") {
                            this.polylineSymbol.maxDistance = parseFloat(value)
                        } else if (name == "LineColor") {
                            this.polylineSymbol.lineColor = CooWasm.ColorObj.fromCssColorString(value)
                        } else if (name == "LineTransparency") {
                            this.polylineSymbol.lineAlpha = parseFloat(value)
                        } else if (name == "LineWidth") {
                            this.polylineSymbol.lineWidth = parseFloat(value)
                        } else if (name == "OutlineColor") {
                            this.polylineSymbol.outlineColor = CooWasm.ColorObj.fromCssColorString(value)
                        } else if (name == "OutlineTransparency") {
                            this.polylineSymbol.outlineAlpha = parseFloat(value)
                        }
                    } else if (pName == "PolygonSymbolComponent") {
                        this.componentPolygonUuid = uuid
                        let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        if (name == "AltitudeMode") {
                            this.polygonSymbol.altitudeMode = value
                        } else if (name == "Altitude") {
                            this.polygonSymbol.altitude = parseFloat(value)
                        } else if (name == "MinVisibleDistance") {
                            this.polygonSymbol.minDistance = parseFloat(value)
                        } else if (name == "MaxVisibleDistance") {
                            this.polygonSymbol.maxDistance = parseFloat(value)
                        } else if (name == "FillColor") {
                            this.polygonSymbol.fillColor = CooWasm.ColorObj.fromCssColorString(value)
                        } else if (name == "FillTransparency") {
                            this.polygonSymbol.fillAlpha = parseFloat(value)
                        }
                    }
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }
        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁图层后触发的函数回调。
         * @returns null 空值。
         * @example
         * // 销毁图层
         * layer = layer.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if (!defined(this.avatarUuid)) {
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.featureLayers = Element.prototype.Map.featureLayers.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndMultiComponent", this.avatarUuid)
                callbackSystem.remove("", "LocateAvatar")
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
                this.componentPolylineUuid = null
                this.componentPolygonUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return FeatureLayer
})